import type { ReactNode } from 'react'

type Variant = 'default' | 'grass' | 'wood' | 'sky' | 'slate'

interface CardProps {
  children: ReactNode
  variant?: Variant
  /** Variant B blocky-beveled border treatment. */
  blocky?: boolean
  className?: string
}

const variantClasses: Record<Variant, string> = {
  default: 'bg-white border-stone-light/60 text-slate-deep',
  grass: 'bg-grass/10 border-grass-dark/40 text-slate-deep',
  wood: 'bg-wood-light/15 border-wood/40 text-slate-deep',
  sky: 'bg-sky/15 border-sky-deep/40 text-slate-deep',
  slate: 'bg-slate-deep border-slate-deeper text-white',
}

export default function Card({
  children,
  variant = 'default',
  blocky = false,
  className = '',
}: CardProps) {
  const shape = blocky
    ? 'block-bevel rounded-none'
    : 'rounded-2xl border shadow-block'
  return (
    <div className={['p-6', variantClasses[variant], shape, className].filter(Boolean).join(' ')}>
      {children}
    </div>
  )
}
